// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XFSP","left":"styles_left__ZBq8h","desktopActions":"styles_desktopActions__3S-IV","title":"styles_title__m0kXE"};